import { render } from "./ChartDemo.vue?vue&type=template&id=d6c61e50"
import script from "./ChartDemo.vue?vue&type=script&lang=js"
export * from "./ChartDemo.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/eAzC_LUi/0/econsultingsistemas/certificadorweb/certificador-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__